import React from 'react';
import Notes from 'Components/Notes';

export default function NotesSection ({notes, handleChange, user}) {
  if (notes || user.isInternal()) {
    return (
      <section className='scene_section'>
        <header>
          Component notes
        </header>
        <Notes text={notes || ''} handleInputChange={handleChange} disabled={!user.isInternal()} />
      </section>
    );
  } else {
    return null;
  }
}



// WEBPACK FOOTER //
// ./src/app/Scenes/ComponentManufacturer/Application/Edit/Notes.jsx